import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class FeedbackEventService {
  private feedbackClosedSource = new Subject<void>();


  feedbackClosed$ = this.feedbackClosedSource.asObservable();


  notifyFeedbackClosed() {
    this.feedbackClosedSource.next();
  }
}


// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/core/feedback-event.service.ts